import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { selectors as apiSelectors } from 'zender-api-client';

import * as appSelectors from '../../../../../selectors';

import Question from './Question.component';

const QuestionContainer = props => <Question {...props} />;

const mapStateToProps = state => ({
	locale: appSelectors.locale.localeSelector(state),
	quiz: apiSelectors.quiz.latestQuizSelector(state),
	questionCount: apiSelectors.quiz.latestQuizQuestionCountSelector(state),
});

const mapDispatchToProps = () => ({});

QuestionContainer.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(QuestionContainer);



// WEBPACK FOOTER //
// ./src/ui/interaction/children/sections/question/Question.container.js